import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SettingsAccessPopupPageRoutingModule } from './settings-access-popup-routing.module';

import { SettingsAccessPopupPage } from './settings-access-popup.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SettingsAccessPopupPageRoutingModule
  ],
  declarations: [SettingsAccessPopupPage]
})
export class SettingsAccessPopupPageModule {}
